import {message} from "./main";

/**
 * @alias Ptx.fn.initCopyToClipboard
 * Initialize copy to clipboard
 */
export function initCopyToClipboard() {
	var copyElement = ".icon-copy-to-clipboard",
		maxLength = 128;

	$(copyElement).off("click").on("click", function (event) {
		var $targetId, selectedElement, selectedText, range, selection;

		$targetId = $(this).data("clipboardTarget");
		selectedElement = document.getElementById($targetId);

		if (selectedElement.nodeName === "INPUT" || selectedElement.nodeName === "TEXTAREA") {
			selectedElement.select();
			selectedElement.setSelectionRange(0, selectedElement.value.length);
			selectedText = selectedElement.value;
		} else {
			range = document.createRange();
			range.selectNode(selectedElement);

			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			selectedText = selection.toString();
		}
		selectedText = selectedText.trim();

		document.execCommand("copy");

		if (selectedText.length > maxLength) {
			message(Ptx.getMsg('common.copied') + " '" + selectedText.substring(0, maxLength) + "...'");
		} else {
			message(Ptx.getMsg('common.copied') + " '" + selectedText + "'");
		}

		event.preventDefault();
	});
}
